import { createSelector } from 'reselect';

export const ordersSelector = (state) => state.orders.items || [];
export const councilsSelector = (state) => state.councils.items || [];
export const usersSelector = (state) => state.users.items || [];

export const councilOrdersSelector = createSelector(
  [ordersSelector, councilsSelector, usersSelector],
  (orders, councils, users) =>
    orders.map((order) => ({
      ...order,
      user: users.find(user => order.user_id === user.id) || null,
      council: councils.find((council) => order.council_id === council.id) || {}
    }))
);
